import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../components/SEO';
import { PageContainer } from '../components/PageHeader';
import { clearPendingShareAccept } from '../features/courseShare/pendingShare';

// DEAD ROUTE (kept, not removed): with embedded checkout there is no cancel
// redirect — abandoning a purchase happens inside Stripe's iframe and the user
// simply stays on /subscription/checkout (or clicks "Back to plans"). The old
// hosted-checkout flow redirected here on cancel; nothing navigates here now.
// The route + this page are retained as a safe landing spot for any stale
// /subscription/cancel links and can be removed once none remain in the wild.
export default function SubscriptionCancelPage() {
    const navigate = useNavigate();

    // Backing out of checkout also abandons any queued "Create in my Graspd"
    // intent, so it can't silently auto-fire later. Re-clicking the share link
    // re-queues it.
    useEffect(() => {
        clearPendingShareAccept();
    }, []);

    return (
        <>
        <SEO
            title="Subscription Cancelled"
            description="Your checkout was cancelled."
            path="/subscription/cancel"
            noindex={true}
        />
        <PageContainer style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '70vh',
            textAlign: 'center',
            padding: 'var(--space-7) var(--space-5)'
        }}>
            {/* Icon */}
            <div style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'var(--glass-bg-light)',
                border: '1px solid var(--border-subtle)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 'var(--space-6)'
            }}>
                <svg
                    width="40"
                    height="40"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="var(--text-tertiary)"
                    strokeWidth="2"
                    strokeLinecap="round" 
                    strokeLinejoin="round"
                >
                    <circle cx="12" cy="12" r="10" />
                    <line x1="12" y1="8" x2="12" y2="12" />
                    <line x1="12" y1="16" x2="12.01" y2="16" />
                </svg>
            </div>

            {/* Title */}
            <h1 style={{
                fontSize: '40px',
                fontWeight: '800',
                letterSpacing: '-0.02em',
                marginBottom: 'var(--space-4)',
                color: 'var(--text-primary)'
            }}>
                No worries
            </h1>

            {/* Description */}
            <p style={{
                fontSize: '18px',
                color: 'var(--text-secondary)',
                marginBottom: 'var(--space-6)',
                maxWidth: '400px',
                lineHeight: '1.6'
            }}>
                You can upgrade to Pro anytime to unlock all features.
            </p>

            {/* Buttons */}
            <div style={{ display: 'flex', gap: 'var(--space-4)' }}>
                <button
                    onClick={() => navigate('/dashboard')}
                    style={{
                        padding: 'var(--space-3) var(--space-5)',
                        borderRadius: 'var(--radius-full)',
                        background: 'var(--btn-primary-bg)',
                        color: 'var(--btn-primary-text)',
                        fontSize: '15px',
                        fontWeight: '600',
                        border: 'none',
                        cursor: 'pointer',
                        transition: 'transform 0.2s, box-shadow 0.2s'
                    }}
                    onMouseOver={(e) => {
                        e.currentTarget.style.transform = 'translateY(-1px)';
                        e.currentTarget.style.boxShadow = 'var(--shadow-md)';
                    }}
                    onMouseOut={(e) => {
                        e.currentTarget.style.transform = 'translateY(0)';
                        e.currentTarget.style.boxShadow = 'none';
                    }}
                >
                    Back to Dashboard
                </button>
            </div>
        </PageContainer>
        </>
    );
}